import React, { useEffect, useState } from "react";
import apiClient, { formatApiError } from "@/api/client";
import { FileText, ExternalLink, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { usePortalAuth } from "@/contexts/PortalAuthContext";

export default function PortalReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = usePortalAuth();

  useEffect(() => {
    apiClient.get("/portal/reports")
      .then(r => setReports(r.data || []))
      .catch(e => toast.error(formatApiError(e)))
      .finally(()=>setLoading(false));
  }, []);

  const fmtSize = (b) => b ? `${(b/1024/1024).toFixed(2)} MB` : "—";
  const API = process.env.REACT_APP_BACKEND_URL;

  if (loading) return <div className="p-10 text-center text-sm text-[#94A3B8]"><Loader2 size={16} className="animate-spin inline mr-2"/>Yükleniyor…</div>;

  return (
    <div className="space-y-5" data-testid="portal-reports">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2"><FileText size={20} className="text-[#4F46E5]"/>Raporlar</h1>
        <p className="text-sm text-[#64748B] mt-1">Ajansınız tarafından sizin için hazırlanan PDF raporları burada bulabilirsiniz.</p>
      </div>

      {reports.length === 0 ? (
        <div className="ky-card p-12 text-center">
          <FileText size={32} className="mx-auto text-[#CBD5E1] mb-3"/>
          <div className="text-sm font-medium text-[#0F172A]">Henüz yayınlanmış rapor yok</div>
          <p className="text-xs text-[#94A3B8] mt-1">Ajansınız bir rapor yayınladığında burada görünecek.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {reports.map(r => {
            const pdfUrl = `${API}/api/portal/reports/${r.id}/pdf?auth=${encodeURIComponent(token)}`;
            return (
              <div key={r.id} className="ky-card p-4 flex items-center gap-4" data-testid={`report-${r.id}`}>
                <div className="w-12 h-12 rounded-lg bg-[#EEF2FF] flex items-center justify-center shrink-0">
                  <FileText size={20} className="text-[#4F46E5]"/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm truncate">{r.name}</div>
                  {r.subtitle && <div className="text-xs text-[#64748B] truncate">{r.subtitle}</div>}
                  <div className="text-[11px] text-[#94A3B8] mt-1">
                    Yayın: {new Date(r.published_at).toLocaleString("tr-TR")} · {fmtSize(r.pdf_size)}
                  </div>
                </div>
                <div className="flex gap-2">
                  <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="ky-btn ky-btn-outline ky-btn-sm" data-testid={`preview-${r.id}`}><ExternalLink size={12}/>Görüntüle</a>
                  <a href={pdfUrl} download className="ky-btn ky-btn-accent ky-btn-sm" data-testid={`download-${r.id}`}><Download size={12}/>İndir</a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
